import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { MdOutlineDateRange } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import CommonCard from '../../../Components/General/CommonCard';
import Button from '../../../Components/UI/Button';
import { Input } from '../../../Components/UI/Input';
import ToggleButton from '../../../Components/UI/ToggleButton';
import useProfile from '../../../Features/useProfile';
import { setAppointmentSetting } from '../../../Store/authSlice';
import classes from './AppointmentsAndFollowUp.module.css';
const AppointmentsAndFollowUp = ({ onSubmit }) => {
  const appointmentSetting = useSelector((state) => state?.authReducer?.appointmentsSettingData);
  const { updateAppointments } = useProfile();
  const dispatch = useDispatch();
  const [timeDuration, setTimeDuration] = useState('');
  useEffect(() => {
    setTimeDuration(appointmentSetting?.appointmentDuration);
  }, [appointmentSetting]);
  return (
    <CommonCard className={classes.cardWrapper}>
      <div className={classes.topField}>
        <div className={classes.mainInfoCard}>
          <span className={classes.circleBg}>
            <MdOutlineDateRange size={20} color="var(--primary-color)" />
          </span>
          <div className={classes.content}>
            <h3>Appointments</h3>
            <p>Manage Appointments</p>
          </div>
        </div>
        <ToggleButton
          value={appointmentSetting?.isAppointment}
          setter={(e) => {
            updateAppointments({ ...appointmentSetting, isAppointment: e }, () => {
              dispatch(setAppointmentSetting({ ...appointmentSetting, isAppointment: e }));
            });
          }}
          id="setting-appointment"
        />
      </div>
      <div
        className={clsx(classes.furtherContent, {
          [classes.hide]: appointmentSetting?.isAppointment
        })}>
        <Row className={classes['mt-16']}>
          <Col sm={6}>
            <Input
              id={'setting-time-duration'}
              type="number"
              placeholder="Duration"
              setter={setTimeDuration}
              value={timeDuration}
              label={'Duration Per Patient'}
              rightIcon={<span className={classes.minutes}>Minutes</span>}
            />
            <p className={classes.durationBottomLabel}>Session time per patients</p>
          </Col>
          <Col sm={6}>
            <div className={classes.followUpContent}>
              <div className={classes.content}>
                <h3>Follow Up</h3>
                <p className={classes['mt-3']}>
                  Allow follow up appointments to be scheduled for walk in patients
                </p>
              </div>
              <ToggleButton
                value={appointmentSetting?.isFollowUp}
                setter={(e) => {
                  updateAppointments({ ...appointmentSetting, isFollowUp: e }, () => {
                    dispatch(setAppointmentSetting({ ...appointmentSetting, isFollowUp: e }));
                  });
                }}
                id="settings-follow up"
              />
            </div>
          </Col>
        </Row>

        <div className={classes.ctaWrapper}>
          <Button
            label={'Save'}
            onClick={() => {
              if (typeof onSubmit === 'function') {
                onSubmit({
                  ...appointmentSetting,
                  appointmentDuration: timeDuration
                });
              }
            }}
          />
        </div>
      </div>
    </CommonCard>
  );
};

export default AppointmentsAndFollowUp;
